import $ from 'jquery'
import text from './text'
import * as utils from './utils'
import { getParam } from 'utilsES';
import * as interaction from './interaction.js';

import "../img/slider/thai_slider-1.jpg";
import "../img/slider/thai_slider-2.jpg";
import "../img/slider/thai_slider-3.jpg";
import "../img/slider/thai_slider-4.jpg";
import "../img/slider/thai_slider-5.jpg";
import "../img/slider/thai_slider-6.jpg";

export default {
	lang: '',
	getLang() {
		return this.lang
	},
	setLang(lang) {
		this.lang = lang;
	},
	changeLang(lang) {
		let param = location.search;
		param = param.replace(/[\?|\&]lang=\w*/g, '');
		if (param) {
			param = param.substring(1);
			param = "&" + param;
		}
		if (lang === "vi") {
			top.window.location.href = `https://dauladailuc3d.vn/dang-ky?eventname=dlssrvtyy&lang=vi${param}`;
		} else if (lang === "thai") {
			top.window.location.href = `https://gevents.37games.com/dlssrvtyy/index.html?lang=thai${param}`;
			// window.open("https://gevents.37games.com/dlssrvtyy/index.html");
		} else {
			top.window.location.href = `https://gevents.37games.com/dlssrvtyy/index.html?lang=zh${param}`;
		}
		this.lang = lang;
		this.initPageLang();
	},
	getText(key) {
		if (this.lang === '') {
			this.lang = "thai";
			// alert('Language init error!')
			return
		}
		return text[getParam('lang') || this.lang][key] || 'error tip'
	},
	initPageLang() {
		const $phonehead = $('.j-phonehead');
		const $popupPhonehead = $('.j-popup-phonehead');
		const $way = $('.j-way');
		const $area = $('.j-area');
		const $areaArrow = $('.j-area-arrow');
		const $wayArrow = $('.j-way-arrow');
		const language = getParam('lang') || this.lang || "thai";
		if (language === '') {
			document.write('')
		}
		this.lang = language;
		$('body').removeClass('vi').removeClass('thai').removeClass('zh').addClass(this.lang);
		document.title = this.getText('title');
		$('.j-phone-block').show();
		$('.j-email-block').hide();
		$('.j-way-list').hide();
		$wayArrow.removeClass('active');
		$('.j-area-list').hide();
		$areaArrow.removeClass('active');
		if (this.lang === 'vi') {
			$way.addClass("disabled");
			$area.addClass("disabled");
			$areaArrow.hide();
			$wayArrow.hide();
			$phonehead.html("84");
			$popupPhonehead.html("84");
			$phonehead.attr('contenteditable', 'false');
			$popupPhonehead.attr('contenteditable', 'false');
			$(".j-serve-link").attr("href", "https://funtapcorp.vn/dieu-khoan");
			$(".j-privacy-link").attr("href", "https://funtapcorp.vn/bao-mat");
		} else if (this.lang === 'thai') { 
			$area.addClass("disabled");
			$areaArrow.hide();
			$way.removeClass("disabled");
			$wayArrow.show();
			$phonehead.html("66");
			$popupPhonehead.html("66");
			$phonehead.attr('contenteditable', 'false');
			$popupPhonehead.attr('contenteditable', 'false');
			
			$(".swiper-slide-1 img").attr("src", "/dlssrvtyy/img/thai_slider-1.jpg");
			$(".swiper-slide-2 img").attr("src", "/dlssrvtyy/img/thai_slider-2.jpg");
			$(".swiper-slide-3 img").attr("src", "/dlssrvtyy/img/thai_slider-3.jpg");
			$(".swiper-slide-4 img").attr("src", "/dlssrvtyy/img/thai_slider-4.jpg");
			$(".swiper-slide-5 img").attr("src", "/dlssrvtyy/img/thai_slider-5.jpg");
			$(".swiper-slide-6 img").attr("src", "/dlssrvtyy/img/thai_slider-6.jpg");
		} else {
			$way.removeClass("disabled");
			$area.removeClass("disabled");
			$areaArrow.show();
			$wayArrow.show();
			$phonehead.html("");
			$popupPhonehead.html("");
			$phonehead.attr('contenteditable', 'true');
            $popupPhonehead.attr('contenteditable', 'true');
		}
		this.initTable()
	},
	initTable() {
		$(".j-language-selected").text(this.getText('languageSelected'));
		$(".j-language-item-text-1").text(this.getText('languagezh'));
		$(".j-language-item-text-2").text(this.getText('languagevi'));
		$(".j-language-item-text-3").text(this.getText('languagethai'));
		$(".j-area-selected").text(this.getText('areaSelected'));
		$(".j-area-item-text-1").text(this.getText('viArea'));
		$(".j-area-item-text-2").text(this.getText('thaiArea'));
		$(".j-area-item-text-3").text(this.getText('qitaArea'));
		$(".j-areaLabel").text(this.getText('area'));
		$(".j-way-item-text-1").text(this.getText('phone'));
		$(".j-way-item-text-2").text(this.getText('email'));
		$(".j-phonehead").attr('placeholder', this.getText('phoneCode'));
		$(".j-phone").attr('placeholder', this.getText('pleasePhone'));
		$(".j-email").attr('placeholder', this.getText('pleaseEmail'));
		$(".j-popup-phonehead").attr('placeholder', this.getText('phoneCode'));
		$(".j-popup-phone").attr('placeholder', this.getText('pleasePhone'));
		$(".j-popup-email").attr('placeholder', this.getText('pleaseEmail'));
		$(".j-serve-link").text(this.getText('serviceItem'));
		$(".j-privacy-link").text(this.getText('privacyItem'));
		$(".j-serve-tip").text(this.getText('toPhoneorEmail'));
		$(".j-bagTip").text(this.getText('toPhoneorEmail'));
		$('.j-way-selected').text(this.getText('phone'));
		$(".j-err-tip").text(this.getText('phoneError'));
		interaction.register.way = "phone";
	}
	
}
